module.exports = Promise.all([
    import("tap-moment"),
    import("tap-modal/tap-modal"),
    import("bootstrap-daterangepicker"),
]).then(deps => {
    let [moment, showModal] = deps;
    showModal = showModal.default;
    moment = moment.default;

    (function($, w) {
        var pluginName = "PayoutGenerator";
        var defaults = {
            date: moment().format("YYYY-MM-DD"),
            name: "up-to",
        };

        function Plugin(element, options) {
            this.element = element;
            this.options = $.extend(true, defaults, options);
            this._defaults = defaults;
            this._name = pluginName;
            this.init();

            return this;
        }

        var template = `<div id="range-holder" class="full-w spaced-top-half">
                    <ul class="normalize">
                        <li> <div class="radio"> <input id="radio2" type="radio" name="range-type-selector" value="all" checked> <label for="radio2"></label> <span>All approved, unpaid commissions</span> </div></li>
                        <li> <div class="radio"> <input id="radio3" type="radio" name="range-type-selector" value="up-to"> <label for="radio3"></label> <span>Only approved, unpaid commissions up to the following date:</span> </div> <input type="text" class="form-control input-sm half-w" name="datepicker" /></li>
                    </ul>`;

        Plugin.prototype = {
            init: function() {
                if (!$(this.element).is("form")) {
                    throw "Payout generator target element should be a form";
                }
                var self = this;
                self.selectedValue = this._defaults.date;

                var dateChanged = function(date) {
                    self.selectedValue = date.format("YYYY-MM-DD");
                };

                var shownCb = function() {
                    $('input[name="datepicker"]')
                        .val(self._defaults.date)
                        .daterangepicker(
                            {
                                singleDatePicker: true,
                                showDropdowns: true,
                                maxDate: moment(),
                                locale: {
                                    format: "YYYY-MM-DD",
                                },
                            },
                            dateChanged,
                        );

                    // Enable / Disable picker
                    $('[name="range-type-selector"]').on("change", function() {
                        var disabled = $('[name="range-type-selector"]:checked').val() !== "up-to";
                        $('input[name="datepicker"]').prop("disabled", disabled);
                    });

                    $('[name="range-type-selector"]').trigger("change");
                };

                // Show the dialog on 'submit'
                $(this.element).on("submit", function(ev) {
                    ev.preventDefault();
                    var $dialog = showModal("Prepare payout lines", template, shownCb, [
                        {
                            text: "Generate",
                            classes: "btn btn-success will-load",
                            callback: function($dialog) {
                                if ($('[name="range-type-selector"]:checked').val() === "up-to") {
                                    var $input = $('<input type="hidden">')
                                        .attr("name", self._defaults.name)
                                        .val(self.selectedValue);

                                    $(self.element).append($input);
                                }

                                $dialog.find(".btn-success").addClass("loading");
                                $dialog.find(".btn").prop("disabled", true);
                                $(self.element).attr("action", $(self.element).data("action"));
                                $(self.element)[0].submit();
                            },
                        },
                        { text: "Cancel" },
                    ]);

                    $dialog.on("hide.bs.modal", function(event) {
                        $(".daterangepicker").remove();
                    });
                });
            },
        };

        $.fn[pluginName] = function(options) {
            var args = arguments;
            if (options === undefined || typeof options === "object") {
                return this.each(function() {
                    if (!$.data(this, "plugin_" + pluginName)) {
                        $.data(this, "plugin_" + pluginName, new Plugin(this, options));
                    }
                });
            } else if (typeof options === "string" && options[0] !== "_" && options !== "init") {
                if (
                    Array.prototype.slice.call(args, 1).length == 0 &&
                    $.inArray(options, $.fn[pluginName].getters) != -1
                ) {
                    var instance = $.data(this[0], "plugin_" + pluginName);
                    return instance[options].apply(instance, Array.prototype.slice.call(args, 1));
                } else {
                    return this.each(function() {
                        var instance = $.data(this, "plugin_" + pluginName);
                        if (instance instanceof Plugin && typeof instance[options] === "function") {
                            instance[options].apply(instance, Array.prototype.slice.call(args, 1));
                        }
                    });
                }
            }
        };
    })(jQuery, window);
});
